<template>
    <div
      class="w-full rounded-lg lg:rounded-xl text-center flex flex-col items-center space-y-2 mb-10 relative max-h-[200px] md:max-h-[900px] overflow-y-auto"
    >
      <NuxtLink 
        class="w-full"
        v-for="county in counties" 
        :key="county.name"
        :to="`/skip-hire/near-me/${county.nameCode}`"
      >
        <NearMeCountyCard 
          :county="county.name"
        />
      </NuxtLink>
    </div>
  </template>
  
  <script setup>
  const regionStore = useRegionStore();

  const counties = computed(() => {
    if (regionStore.isPopular()) {
        return popularCounties.value;
    }
    return selectedCounties.value;
  });

  const selectedCounties = computed(() => {
    const activeRegion = regionStore.currentLocationSlug;
    return regionStore.getCountiesByRegionSlug(
        regionStore.currentRegion
    );
  });
  const popularCounties = computed(() => {
    return [
        { name: "Greater London", nameCode: "greater-london" },
        { name: "West Midlands", nameCode: "west-midlands" },
        { name: "Greater Manchester", nameCode: "greater-manchester" },
        { name: "West Yorkshire", nameCode: "west-yorkshire" },
        { name: "Hampshire", nameCode: "hampshire" },
        { name: "Kent", nameCode: "kent" },
        { name: "Essex", nameCode: "essex" },
        { name: "Lancashire", nameCode: "lancashire" },
        { name: "Merseyside", nameCode: "merseyside" },
        { name: "South Yorkshire", nameCode: "south-yorkshire" },
        { name: "Surrey", nameCode: "surrey" },
        { name: "Devon", nameCode: "devon" },
        { name: "Hertfordshire", nameCode: "hertfordshire" },
        { name: "Nottinghamshire", nameCode: "nottinghamshire" },
        { name: "North Yorkshire", nameCode: "north-yorkshire" },
        { name: "Tyne and Wear", nameCode: "tyne-and-wear" },
        { name: "Staffordshire", nameCode: "staffordshire" },
        { name: "Lincolnshire", nameCode: "lincolnshire" },
        { name: "Cheshire", nameCode: "cheshire" },
        { name: "Derbyshire", nameCode: "derbyshire" }
    ];
  });
  </script> 